export default __webpack_public_path__ + "static/media/worksheet-submitted-icon.14da386d.png";